module.exports = __webpack_public_path__ + "img/sld_delta_star_transformer_t1_b1_light.525df3d9.svg";